export default "__VITE_ASSET__BfkU0Yz2__"